<template>
  <div class="SocialMedia">hola2</div>
</template>

<script>
export default {
  name: 'SocialMedia',
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  async created() {
    // var isiOS =
    //     navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
    //   isAndroid = navigator.userAgent.match('Android');
    // if (isiOS || isAndroid) {
    //   document.getElementById('loader').src =
    //     'https://apps.apple.com/mx/app/golstats/id979011901' + window.location.search + window.location.hash;
    //   let fallbackLink = isAndroid
    //     ? 'https://play.google.com/store/apps/details?id=com.golstats' + window.location.search + window.location.hash
    //     : 'https://apps.apple.com/mx/app/golstats/id979011901' + window.location.search + window.location.hash;
    //   window.setTimeout(function() {
    //     window.location.replace(fallbackLink);
    //   }, 1);
    //   alert('Es movil');
    // } else {
    //   alert('Es PC');
    //   // Redirect to your webpage
    //   window.location.href = 'http://192.168.0.9:8080/bets'; // Replace with your actual webpage URL
    // }

    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check if the user agent indicates a mobile device
    if (/android/i.test(userAgent) || /iPad|iPhone|iPod/i.test(userAgent)) {
      alert('Es movil');
      // Redirect to the app store for iOS or Android
      if (/android/i.test(userAgent)) {
        alert('Es android');
        if ('getInstalledRelatedApps' in navigator) {
          navigator.getInstalledRelatedApps().then(function(apps) {
            var isAppInstalled = false;
            for (var i = 0; i < apps.length; i++) {
              if (apps[i].id === 'com.golstats') {
                isAppInstalled = true;
                break;
              }
            }
            if (isAppInstalled) {
              alert('The app is installed on the device.');
            } else {
              var googlePlayLink = 'https://play.google.com/store/apps/details?id=com.golstats';
              window.location.href = googlePlayLink;
            }
          });
        } else {
          alert('The getInstalledRelatedApps() method is not supported.');
        }
      }
      if (/iPad|iPhone|iPod/i.test(userAgent)) {
        var appStoreLink = 'https://apps.apple.com/mx/app/golstats/id979011901';
        window.location.href = appStoreLink;
        alert('Es ios');
        // if ('getInstalledRelatedApps' in navigator) {
        //   navigator.getInstalledRelatedApps().then(function(apps) {
        //     var isAppInstalled = false;
        //     for (var i = 0; i < apps.length; i++) {
        //       if (apps[i].id === 'golstats') {
        //         isAppInstalled = true;
        //         break;
        //       }
        //     }
        //     if (isAppInstalled) {
        //       alert('The app is installed on the device.');
        //     } else {
        //       alert('The app is not installed on the device.');
        //     }
        //   });
        // } else {
        //   alert('The getInstalledRelatedApps() method is not supported.');
        // }
      }
    } else {
      alert('Es PC');

      // Redirect to your webpage
      window.location.href = 'http://192.168.0.9:8080/bets'; // Replace with your actual webpage URL
    }
  },
};
</script>
<style lang="scss" scoped></style>
